import { WelcomeComponent } from '../components/welcome/welcome.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { IsAuthenticatedGuard } from '../guards/is-authenticated.guard';
import { UnauthorizedComponent } from '../components/unauthorized/unauthorized.component';
import { HasAppViewPermissionGuard } from '../guards/has-app-view-permission.guard';
import { StatusComponent } from '../components/status/status.component';
import { UpdateComponent } from '../components/update/update.component';
import { EcaLoginComponent } from '../components/login/eca-login.component';
import { UpdateClientComponent } from '../components/update/update-client/update-client.component';
import { UpdateServiceComponent } from '../components/update/update-service/update-service.component';
import { UpdateIssueComponent } from '../components/update/update-issue/update-issue.component';
import { UpdateMaintenanceComponent } from '../components/update/update-maintenance/update-maintenance.component';
import { ViewpublicsiteComponent } from '../components/update/viewpublicsite/viewpublicsite.component';
import { RedirectGuard } from '../guards/redirect.guard';
import { UpdateStatusTypesComponent } from '../components/update/update-status-types/update-status-types.component';


export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'status/welcome'
  },
  {
    path: 'all/eca-insight-status-ui',
    redirectTo: 'status/welcome',
    pathMatch: 'full'
  },

  {
    path: ':clientCode',
    component: StatusComponent,
    pathMatch: 'full',
    canActivate: [RedirectGuard],
    data: {
      widaRedirectUrl: 'https://status.drcedirect.com/WIDA'
    }
  },
  {
    path: 'status/login',
    component: EcaLoginComponent
  },
  {
    path: 'status/update',
    canActivate: [IsAuthenticatedGuard, HasAppViewPermissionGuard],
    component: UpdateComponent,
    children: [
      { path: '', redirectTo: 'services', pathMatch: 'full' },
      { path: 'client', component: UpdateClientComponent, canActivate: [IsAuthenticatedGuard, HasAppViewPermissionGuard] },
      { path: 'services', component: UpdateServiceComponent, canActivate: [IsAuthenticatedGuard, HasAppViewPermissionGuard] },
      { path: 'issues', component: UpdateIssueComponent, canActivate: [IsAuthenticatedGuard, HasAppViewPermissionGuard] },
      { path: 'status-list', component: UpdateStatusTypesComponent, canActivate: [IsAuthenticatedGuard, HasAppViewPermissionGuard] },
      { path: 'maintenance', component: UpdateMaintenanceComponent, canActivate: [IsAuthenticatedGuard, HasAppViewPermissionGuard] },
      { path: 'viewpublicsite', component: ViewpublicsiteComponent, canActivate: [IsAuthenticatedGuard, HasAppViewPermissionGuard] }
    ]
  },
  {
    path: 'status/unauthorized',
    component: UnauthorizedComponent,
    canActivate: [IsAuthenticatedGuard]
  },
  {
    path: 'status/welcome',
    component: WelcomeComponent,
    canActivate: [RedirectGuard],
    data: {
      widaRedirectUrl: 'https://status.drcedirect.com/WIDA'
    }
  },
  { path: '**', redirectTo: 'status/welcome' }

];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(
      appRoutes, { useHash: false })
  ],
  declarations: []
})
export class AppRoutingModule {

}
